import React, { FC, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import { getDDMMYYYFormat, isDateInRange } from "../../../../helper/dateTimeHelper";
import CreateRequestButton from "../../components/CreateRequestButton";
import { AiOutlineFilter } from "react-icons/ai";
import moment, { Moment } from "moment";
import { ExportFileExcel } from "../../info-technology-process/components";
import { compareRequestStatus, getRequestStatusHasAssigneeOptions } from "../../utils";
import { useSercurityCardUnitColumn } from "./hooks/use-sercurity-card-unit-column";
import { useSecurityCardUnitsRequests } from "./hooks";
import { Table, UserManual } from "../../../../components";

export const ProcessSecurityControlCardsToExternalUnits: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { columns } = useSercurityCardUnitColumn();
  const {
    mappedSecurityCardUnitsMyRequests,
    mappedSecurityCardUnitsRequests = [],
    isLoading,
    guideLink,
  } = useSecurityCardUnitsRequests();

  const getCardTypeLabel = (cardTerm: string, cardType: string) => {
    if (cardTerm === "longTerm") {
      switch (cardType) {
        case "evict":
          return "Gia hạn";
        case "provide":
          return "Cấp mới";
        case "renew":
          return "Cấp lại";
        default:
          return "";
      }
    } else {
      switch (cardType) {
        case "provide":
          return "Cấp thẻ";
        case "renew":
          return "Cấp lại thẻ";
        default:
          return "";
      }
    }
  };

  const [filters, setFilters] = useState<any>({
    createdDateTime: null,
    eRequestStatus: null,
  });

  const filteredDataSource = useMemo(() => {
    let dataSource = [...mappedSecurityCardUnitsRequests];
    if (filters.eRequestStatus) {
      dataSource = dataSource.filter((e: any) => compareRequestStatus(e.eRequestStatus, filters?.eRequestStatus!));
    }
    if (filters.createdDateTime) {
      const [startDate, endDate]: [Moment, Moment] = filters.createdDateTime;
      dataSource = dataSource.filter((e: any) => {
        const createDate = moment(e.createdDateTime);
        return isDateInRange(createDate, startDate.startOf("day"), endDate.endOf("day"));
      });
    }

    return dataSource;
  }, [filters, mappedSecurityCardUnitsRequests]);

  const requestStatusHasAssigneeOptions = getRequestStatusHasAssigneeOptions("Đã cấp mới");

  const flattedData = mappedSecurityCardUnitsRequests.map((record: any) => ({
    createdDateTime: getDDMMYYYFormat(record.createdDateTime),
    eRequestStatus: record.eRequestStatus,
    eRequestPersonName: record.createdByName,
    ePhoneNumber: record.ePhoneNumber,
    eDepartment: record.eDepartment,
    eUnit: record.eUnit,
    eBaseId: record.eBaseId,
    ePurpose: record.ePurpose,
    eRequestStatusText: requestStatusHasAssigneeOptions.find((e) => e.value === record.eRequestStatus)?.label,
    eSuggestion: getCardTypeLabel(record.eStage, record.eSuggestion),
  }));

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <UserManual title="CẤP THẺ KSAN CHO ĐƠN VỊ NGOÀI" icon={<Icon.IdCard />} guideLink={guideLink} />
        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton
              onClick={() => history.push(Routes.createSercurityCardUnitsPage.path.replace(":id", "0"))}
            />
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={mappedSecurityCardUnitsMyRequests}
            onRow={(record) => ({
              onClick: () => history.push(Routes.detailExternalSercurityCardUnitsPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>

        <Box
          title="Các yêu cầu cần duyệt"
          titleRight={
            <ExportFileExcel
              exportContent={{
                fileName: "Danh sach yeu cau can duyet cap the KSAN cho don vi ben ngoai",
                content: [
                  { header: "Loại thẻ", dataIndex: "eSuggestion" },
                  {
                    header: "Người yêu cầu",
                    dataIndex: "eRequestPersonName",
                  },
                  { header: "SĐT Người yêu cầu", dataIndex: "ePhoneNumber" },
                  { header: "Cơ quan/Đơn vị", dataIndex: "eDepartment" },
                  { header: "Đơn vị", dataIndex: "eUnit" },
                  { header: "Căn cứ theo nhu cầu", dataIndex: "eBaseId" },
                  { header: "Mục đích", dataIndex: "ePurpose" },
                  { header: "Trạng thái", dataIndex: "eRequestStatusText" },
                ],
              }}
              data={flattedData}
              initialValues={filters}
              requestStatusOptions={requestStatusHasAssigneeOptions}
              onChange={(_, allValues: any) => setFilters(allValues)}
            >
              <div>
                <CreateRequestButton label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
              </div>
            </ExportFileExcel>
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={filteredDataSource}
            onRow={(record) => ({
              onClick: () => history.push(Routes.detailExternalSercurityCardUnitsPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>
      </div>
    </div>
  );
});
